export default __webpack_public_path__ + "static/apple-podcasts-445a1b31499ec96ac4d3b37e37eaa6bd.svg";